module.exports = __webpack_public_path__ + "img/made-raw-material.b8580d79.svg";